module.exports = __webpack_public_path__ + "7abb29f9e854f8ac3a771b8aa5c19402.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/shared/images/logo-dark.png
// module id = 425
// module chunks = 0